import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.99956 2V1H6.99956V10C6.99956 12.3933 6.51742 15.311 6.02101 17.669C5.77454 18.8397 5.52796 19.8569 5.34314 20.5807C5.25078 20.9425 5.17398 21.2304 5.12052 21.4271C5.09379 21.5255 5.0729 21.6009 5.05882 21.6514L5.04295 21.7079L5.03908 21.7216L5.03801 21.7254L4.67383 23H10.2803L11.2803 19H12.7188L13.7188 23H19.3253L18.9609 21.7247L18.96 21.7216L18.9562 21.7079L18.9403 21.6514C18.9262 21.6009 18.9053 21.5255 18.8786 21.4271C18.8251 21.2304 18.7483 20.9425 18.656 20.5807C18.4712 19.8569 18.2246 18.8397 17.9781 17.669C17.4817 15.311 16.9996 12.3933 16.9996 10V1H14.9996V2H8.99956ZM14.9996 4V5H8.99956V4H14.9996ZM13.0039 8.99805V11.002H11V8.99805H13.0039Z"}}]};

const LighthouseFilled = Vue.extend<IconProps>({
  name: 'LighthouseFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'lighthouse-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LighthouseFilled;
